import { render, staticRenderFns } from "./addresstable.vue?vue&type=template&id=13af7268"
import script from "./addresstable.vue?vue&type=script&lang=js"
export * from "./addresstable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports